import React from 'react'
import { graphql, compose } from 'react-apollo'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router-dom'

import { Loader, Form, TextInput } from '../../../UI'
import UPDATE_LOCAL_TOUR from '../../../../graphql/ActivitySteps/UpdateLocalTourBookingNotice.graphql'
import { NotificationManager } from 'react-notifications';

class BookingNotice extends React.Component {
  state = {
    saving: false,
    error: false
  }

  componentDidMount() {
    this.setState({
      notifyBefore: this.props.currentSteps.notifyBefore || ''
    })
  }

  handleSubmit = values => {
    const { data, updateLocalTour, history, currentSteps } = this.props

    if (values.notifyBefore) {
      this.setState({
        saving: true,
        error: ''
      })

      updateLocalTour({
        variables: {
          id: currentSteps.id,
          notifyBefore: parseInt(values.notifyBefore),
          activityStatus: 'WaitingForApproval'
        }
      }).then(() => {
        this.setState({
          saving: ''
        })
        this.props.updateSteps()
        if (data.allLocalTours && data.allLocalTours[0]) {
          history.push(`/activity-steps/${data.allLocalTours[0].id}/finish`)
        } else {
          history.push('/activity-steps/finish')
        }
        NotificationManager.success('Booking notice updated', 'Success', 5000)
      }).catch(err=>NotificationManager.error('Error while updating booking notice', 'Error', 5000))
    } else {
      this.setState({
        error: 'Required field is empty'
      })
    }
  }

  render() {
    const { t } = this.props
    const { saving, notifyBefore } = this.state

    if (this.props.loading) {
      return <Loader showLoader={true} />
    }

    return (
      <div className="steps-screen__form step-form faded-container">
        <div className="steps-screen__form-title">{t('booking_notice')}</div>
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger steps-submit-btn"
          submitBtnName={t('publish_activity')}
          submittingToServer={saving}
        >
          <div className="steps-screen__form-input-area">
            <div className="steps-screen__form-subtitle">{t('notify_people')}</div>
            <div className="form-group row form-section__centered-row">
              <label htmlFor="activity-amount" className="event__form-label col-md-3 control-label mb-0">
                {t('days_before')}
              </label>
              <div className="col-md-3">
                <TextInput type="text" initialValue={notifyBefore} id="notifyBefore" extraClass="event__form-input" placeholder={'2'} />
              </div>
              <small className="text-danger">{this.state.error}</small>
            </div>
          </div>
        </Form>
      </div>
    )
  }
}

const enhance = compose(
  translate('activity_steps'),
  graphql(UPDATE_LOCAL_TOUR, {
    name: 'updateLocalTour'
  }),
  withRouter
)

export default enhance(BookingNotice)



// WEBPACK FOOTER //
// src/components/ActivitySteps/Steps/TimesLocation/BookingNotice.jsx